var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136.8 144.3",
    style: {
      enableBackground: "new 0 0 136.8 144.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    className: "st0",
    d: "M130,72.6c-0.6-10.3-2.9-20.4-8-29.6c-7.3-13.1-19-23.1-33.1-28.3c-29.2-10.1-61.3,3-75.1,30.6 c-9,18.2-9.2,41.3-2,60.2c1.6,4.2,3.6,8.1,6,11.8c7.3,11,18,19.3,30.4,23.6c18.3,6.2,38.4,3.6,54.5-7.1 c15.1-10.3,24.8-26.7,26.8-44.9C130.1,83.6,130.3,78.1,130,72.6 M123.1,80.2L123.1,80.2c-0.6,30.6-24.8,55.3-54.7,55.3 s-54-24.6-54.6-55.3h0c0-0.2,0-0.4,0-0.6s0-0.4,0-0.5h0c0.5-32.5,24.8-58.7,54.6-58.7S122.5,46.5,123,79h0c0,0.2,0,0.4,0,0.5 S123.1,80,123.1,80.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    className: "st0",
    d: "M0.7,66.6c2.2-20.1,13-38.3,29.7-49.8C48.2,5,70.5,2.1,90.7,9c13.8,4.8,25.6,14,33.7,26.1 c2.7,4.1,4.9,8.5,6.7,13.1c3.5,9.2,5.4,18.9,5.6,28.7c0.4-11.6-1.6-23.2-5.6-34c-1.7-4.6-4-9-6.7-13.1 c-8.1-12.2-19.9-21.4-33.7-26.1c-20.3-6.9-42.6-4-60.4,7.8C13.7,23,2.8,41.1,0.7,61.3c-0.5,5-0.7,10.1-0.6,15.1 C0.1,73.1,0.3,69.8,0.7,66.6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    className: "st1",
    width: 136.8,
    height: 144.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnIconWhite);
export default __webpack_public_path__ + "static/media/OwnIconWhite.522844fd4de4cc4ccffbe14c9d1c23ea.svg";
export { ForwardRef as ReactComponent };